import { render, staticRenderFns } from "./ProjectMainInfo.vue?vue&type=template&id=2138551d&"
import script from "./ProjectMainInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectMainInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports